jQuery(document).on('click', 'td.calendar-day-edit, td.calendar-day-event', function(event) {
    if (!STUDIP.CalendarDialog.dialogDisabled) {
        STUDIP.CalendarDialog.dialogDisabled = false;
        var elem = jQuery(this).find('a').first();
    if (_.isString(elem.attr('href'))) {
            STUDIP.Dialog.fromURL(elem.attr('href'), {title: elem.attr('title')});
        event.preventDefault();
    } else {
        return false;
    }
    }
});


jQuery(document).on('click', 'div.calendar-ecampus-link a', function (event) {
    window.open(this.href, '_top');
    STUDIP.CalendarDialog.dialogDisabled = true;
    event.preventDefault();
});
